export default __webpack_public_path__ + "static/media/5821393.4d1a583d.png";